import React from 'react';
import {Filter, X} from 'lucide-react';
import Button from './Button';

// « Filtres actifs » bar on the teal theme: one soft teal chip per applied
// filter (same tint as Button variant="tinted") and a button to clear them all.
// chips: [{key, label, icon?, color? (dot, e.g. a category colour), mono?, onRemove}]

export const FilterChip = ({label, icon: Icon, color, mono, onRemove}) => (
    <span className={`inline-flex items-center gap-1.5 h-7 pl-3 pr-1 rounded-full text-xs font-medium
                      bg-primary/10 dark:bg-primary/20 text-primary-dark dark:text-primary
                      border border-primary/20 dark:border-primary/30 ${mono ? 'font-mono' : ''}`}>
        {color && <span className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{backgroundColor: color}}/>}
        {Icon && <Icon className="w-3.5 h-3.5 flex-shrink-0"/>}
        <span className="truncate max-w-[16rem]">{label}</span>
        <button type="button" onClick={onRemove} aria-label={`Retirer le filtre ${label}`}
                className="p-0.5 rounded-full hover:bg-primary/15 dark:hover:bg-primary/30 transition-colors">
            <X className="w-3.5 h-3.5"/>
        </button>
    </span>
);

const ActiveFilters = ({chips, onClearAll, clearLabel = 'Effacer les filtres'}) => chips.length === 0 ? null : (
    // Edge-to-edge strip under the toolbar (no radius / outer border), like the
    // search bar above it.
    <div className="flex flex-wrap items-center gap-2 px-4 py-2.5 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
        <span className="flex items-center gap-2 mr-1 text-sm font-medium text-gray-600 dark:text-gray-300">
            <Filter className="w-4 h-4 text-primary"/> Filtres actifs :
        </span>
        {chips.map(({key, ...chip}) => <FilterChip key={key} {...chip}/>)}
        {onClearAll && (
            <Button variant="ghost" size="sm" icon={X} onClick={onClearAll} className="ml-auto">
                {clearLabel}
            </Button>
        )}
    </div>
);

export default ActiveFilters;
